module.exports = __webpack_public_path__ + "media/images/gallery-image10-522e137027e611affda23ae9b08a5be9.webp";